module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/classic_mobile-24e8b5a5a82fa592213f58ff7642100b.webp";